import React from 'react'
import DeleteConfirmationDialog from './DeleteConfirmationPopup';

const UnsavedChangesPopup = ({ open, handleClose = () => { }, handleSubmission = () => { } }) => {
    return (
        <DeleteConfirmationDialog
            open={open}
            handleClose={handleClose}
            heading={"Unsaved Changes"}
            subheading={"You have unsaved changes. Closing now will discard these changes. Are you sure you want to proceed?"}
            handleSubmission={handleSubmission}
            ActionText={"Discard Changes"}
            CancelText={"Continue Editing"}
            key={"Unsaved Changes"}
            sx={{
                '& .MuiDialog-paper': {
                    width: '100%',
                    maxWidth: '500px',
                    // marginLeft: "calc(80px + 16px)"
                }
            }}
        />
    )
}

export default UnsavedChangesPopup